import React, { useEffect, useState } from "react";
import "./oneZaim.scss";

const ONE_ZAIM_LABEL_COLOR = {
  "Первый займ 0%": "blue",
  "С любой КИ": "orange",
};

const OneZaim = ({ dat }) => {
  const [updatedOrderLink, setUpdatedOrderLink] = useState(dat.order);

  const getParamsFromCurrentUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      pid: urlParams.get("pid"), // Извлекаем значение параметра `pid`
      adids: urlParams.get("af_ad"), // Извлекаем значение параметра `af_ad` (для adids)
      agids: urlParams.get("af_adset_id"), // Извлекаем значение параметра `af_adset_id` (для agids)
      cids: urlParams.get("campaign_id"), // Извлекаем значение параметра `campaign_id` (для cids)
    };
  };

  // Функция для формирования новой ссылки
  const generateUpdatedOrderLink = () => {
    const { pid, adids, agids, cids } = getParamsFromCurrentUrl(); // Извлекаем параметры из URL

    let newLink = dat.order;

    // Добавляем параметр adids[af_ad]
    if (adids) {
      newLink += `&aff_sub2=adids${encodeURIComponent(adids)}`;
    }

    // Добавляем параметр agids[af_adset_id]
    if (agids) {
      newLink += `agids${encodeURIComponent(agids)}`;
    }

    // Добавляем параметр cids[campaign_id]
    if (cids) {
      newLink += `cids${encodeURIComponent(cids)}`;
    }

    // Добавляем параметр aff_sub2 с pid
    if (pid) {
      const affSub2Value = `cnids${pid}`;
      newLink += `${encodeURIComponent(affSub2Value)}`;
    }

    // Если ни один параметр не найден, возвращаем оригинальную ссылку
    if (!pid && !adids && !agids && !cids) {
      console.warn(
        "Параметры 'pid', 'af_ad', 'af_adset_id', 'campaign_id' не найдены в текущем URL."
      );
      return dat.order;
    }

    return newLink;
  };

  // При монтировании компонента формируем новую ссылку
  useEffect(() => {
    const newLink = generateUpdatedOrderLink();
    setUpdatedOrderLink(newLink); // Обновляем состояние с новой ссылкой
  }, []);

  // Функция для отправки данных о конверсии
  const gtag_report_conversion = (url) => {
    var callback = function () {
      if (typeof url !== "undefined") {
        window.open(updatedOrderLink, "_blank"); // Перенаправляем пользователя по новой ссылке
      }
    };
    window.gtag("event", "conversion", {
      send_to: "AW-16701053115/dMPUCJyP7vwZELux15s-", // Ваш идентификатор конверсии
      event_callback: callback,
    });
    return false;
  };

  return (
    <div className="oneZaim">
      <div className="oneZaim__wrapper">
        <header className="onezaim-header">
          <div className="onezaim-header__info">
            <div className="oneZaim__wrapper-img">
              <img src={dat.screen} alt="screen" />
            </div>
            <h2>{dat.name}</h2>
          </div>
          <div className="onezaim-header__stars">
            {dat.stars}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 1024 1024"
            >
              <path
                fill="#38a1ff"
                d="m908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5c-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1l-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2c17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9l183.7-179.1c5-4.9 8.3-11.3 9.3-18.3c2.7-17.5-9.5-33.7-27-36.3"
              ></path>
            </svg>
          </div>
        </header>
        <label className={`onezaim-label ${ONE_ZAIM_LABEL_COLOR[dat.ytp]}`}>
          {dat.ytp}
        </label>
        <div className="oneZaim__wrapper-money">
          <h2>
            <span>
              {dat.summMid} {dat.summMax} ₽
            </span>
            <span>Сумма</span>
          </h2>
          <h2>
            до {dat.daysLoan}
            <span>Срок</span>
          </h2>
          <h2>
            {dat.successLoan}
            <span>Одобрение</span>
          </h2>
        </div>
        <a
          href={updatedOrderLink} // Используем обновленную ссылку
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault(); // Предотвращаем переход по ссылке
            gtag_report_conversion(updatedOrderLink); // Вызываем конверсию
          }}
        >
          {dat.orderButtonText || "Оформить"}
        </a>
      </div>
    </div>
  );
};

export default OneZaim;
